import styled from 'styled-components/macro';

export const TeamKitMatch = styled.div`
  width: 100%;
  min-height: 100%;
  display: flex;
`;

export const TeamColumn = styled.div`
  position: relative;
  width: 100%;
  min-height: 100%;
  position: relative;
  background-color: ${({ type, theme }) =>
    type === 'local' ? theme.white : theme.dark4};

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    width: 100%;
    min-height: 100%;
  }
`;

export const ShieldBackground = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background-image: url(${({ image }) => image});
  background-repeat: no-repeat;
  background-size: 100%;
  background-position-x: ${({ type }) => (type === 'local' ? '-21vw' : '21vw')};
  filter: grayscale(100%);
  z-index: 0;
  opacity: ${({ type }) => type === 'local' && '0.1'};

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    width: 100%;
    background-position-x: -35vw;
  }
`;

export const StatsColum = styled.div`
  width: 100%;
  min-height: 100%;
  background-color: ${props => props.theme.dark5Opacity};
`;

export const TeamHeader = styled.div`
position: relative;
  width: 100%;
  display: flex;
  flex-direction:column;
  ${({ type, theme }) =>
    type === 'local' &&
    `align-items:flex-start;background-color:${theme.white};`}
  ${({ type, theme }) =>
    type === 'visitor' &&
    `align-items:flex-end;background-color:${theme.dark4Opacity};`}
  ${({ type }) => type === 'referee' && `align-items:center;`}
  padding:10px 25px;

  p{
    font-family: ${props => props.theme.primaryFontLight};
    font-size: ${props => props.theme.paragraphMedium}px;
    text-transform: uppercase;
    margin-bottom:3px;
    ${({ type }) => type === 'local' && 'align-items:flex-start;'}
    ${({ type }) => type === 'visitor' && 'align-items:flex-end;'}
    ${({ type }) => type === 'referee' && 'align-items:center;'}
    color: ${({ theme, type }) =>
      type === 'local' ? theme.dark : theme.white};

    &:last-child{
      font-family: ${props => props.theme.primaryFontBold};
        font-weight: 200;
    }
  }

  img {
  height: ${({ theme }) => theme.shieldBig}px;
  margin: ${({ type }) => (type === 'local' ? '0 0 0 10px' : '0 10px 0 0')};
  }
`;

export const TeamKit = styled.div`
  min-height: 100%;
`;

export const TeamKitList = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  background-color: ${({ theme }) => theme.white};
`;

export const TeamKitListColumn = styled.div`
  width: 50%;
  background-color: ${({ theme, type }) =>
    type === 'local' ? theme.lightWithOpacity : theme.dark4Opacity};
  padding: 30px 30px 80px;
  display: flex;

  table {
    padding: 0 20px 0;

    th {
      text-transform: uppercase;
      ${({ type, theme }) => type === 'visitor' && `color:${theme.white};`}

      &:nth-child(1) > div {
        display: block;
        text-align: center;
      }

      &:nth-child(4) > div {
        display: block;
        text-align: center;
      }
      &:nth-child(5) > div {
        display: block;
        text-align: center;
      }
    }

    td {
      text-transform: capitalize;

      &:nth-child(1) {
        text-align: center;
        font-family: ${props => props.theme.primaryFontBold};
        font-weight: 200;
      }
      &:nth-child(3) {
        font-family: ${props => props.theme.primaryFontBold};
        font-weight: 200;
      }
      &:nth-child(4) {
        text-align: center;
      }
      &:nth-child(5) {
        text-align: center;
        font-family: ${props => props.theme.primaryFontBold};
        font-weight: 200;
      }
    }
  }
`;

export const KitDisplayColumn = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  ${({ type, theme }) =>
    type === 'away' && `background-color:${theme.dark4Opacity};`}
  z-index:1;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    align-items: center;
  }
`;

export const KitColumn = styled.div`
  width: 150px;
  min-height: 600px;
  margin: 0 20px;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    width: 35%;
    margin: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: ${({ isInfo }) => (isInfo ? 'flex-start' : 'center')};
    padding: ${({ isInfo }) => (isInfo ? '20px 0 0' : '0')};
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    min-height: 62vh;
  }
`;

export const ShirtTile = styled.div`
  width: 100%;
  height: 185px;
  background-image: url(${({ image }) => image});
  background-repeat: no-repeat;
  background-size: 150%;
  background-position: center;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    height: 154px;
    background-size: 185px;
  }
`;

export const PantsTile = styled.div`
  width: 100%;
  height: 147px;
  background-image: url(${({ image }) => image});
  background-repeat: no-repeat;
  background-size: 150%;
  background-position: center;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    height: 130px;
    background-size: 194px;
  }
`;

export const SocksTile = styled.div`
  width: 100%;
  height: 147px;
  background-image: url(${({ image }) => image});
  background-repeat: no-repeat;
  background-size: 150%;
  background-position: center;

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    height: 145px;
    background-size: 226px;
  }
`;
